"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const heatprotectionhair = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-heatprotectionhair` : '') + (description ? ` desc-heatprotectionhair` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-heatprotectionhair"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-heatprotectionhair"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_26123_2704)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.11 1.87c3.15.06 5.45 1 7.03 2.56a9.86 9.86 0 0 1 2.66 5.86c.59 4.42-.74 9.6-2.1 13a.75.75 0 0 1-1.4-.55c1.33-3.3 2.55-8.2 2.02-12.25-.27-2-.96-3.75-2.23-5-1.25-1.23-3.15-2.07-6-2.12a.75.75 0 0 1 .02-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.15 9.31c.4.06.69.45.63.86-.63 4.1.53 9.16 1.82 12.58a.75.75 0 1 1-1.4.53c-1.33-3.53-2.6-8.87-1.9-13.34.06-.41.44-.7.85-.63Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.96 6.8a.78.78 0 0 1 .57.37c.05.07.08.15.1.2l.1.3a35.3 35.3 0 0 1 .23.84 7 7 0 0 0 .7 1.75c.35.52.62.62.8.67l.22.05.3.09c.25.1.52.26.71.6.1.17.13.36.14.46l.02.42a13.25 13.25 0 0 1-.83 3.97 7.63 7.63 0 0 1-2.28 3.32 23.96 23.96 0 0 0 .33 2.46l.06.22a.75.75 0 0 1-1.11 1 1.31 1.31 0 0 1-.28-.43 9.5 9.5 0 0 1-.31-1.35 23 23 0 0 1-.13-1.15 4.6 4.6 0 0 1-2.75-.02c-.03.38-.07.8-.14 1.18-.06.35-.15.71-.27 1.03-.12.27-.33.68-.74.88a.75.75 0 0 1-.72-1.31 3.63 3.63 0 0 0 .26-.85c.1-.59.13-1.25.13-1.7a8.18 8.18 0 0 1-2.28-2.86c-.49-.97-.82-1.98-1-2.87a7.18 7.18 0 0 1-.14-1.24c0-.37.03-.74.15-1.06.11-.3.34-.5.55-.63a2 2 0 0 1 .64-.24c.4-.1.9-.14 1.36-.17.49-.04.97-.08 1.42-.15.45-.08.82-.19 1.09-.33a4.32 4.32 0 0 0 1.52-1.75l.26-.49.24-.44c.06-.12.15-.27.25-.4.05-.06.13-.14.23-.21.1-.08.28-.17.5-.17h.1Zm-.32 2.53a5.66 5.66 0 0 1-2.05 2.23c-.49.27-1.05.4-1.57.5-.53.08-1.08.12-1.55.16a8.53 8.53 0 0 0-1.3.18l-.02.4c0 .27.04.6.12.98.15.75.44 1.64.86 2.49.88 1.73 2.19 3.02 3.8 3.02 1.8 0 2.98-1.44 3.7-3.3a11.75 11.75 0 0 0 .72-3.45v-.1h-.02l-.28-.07a2.83 2.83 0 0 1-1.64-1.28 7.24 7.24 0 0 1-.77-1.76Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.88 2.68A1.2 1.2 0 1 1 5.95 3.9a1.2 1.2 0 0 1-2.07-1.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95-.06c.86-.23 1.78-.1 2.56.35 1.7 1 3.82 3.13 4.55 3.9.18.18.3.41.35.66l.01.1c.04.29-.03.58-.17.83l-1.03 1.76a1.33 1.33 0 0 1-1.47.62c-.66-.17-2.03-.54-3.38-1.03l-1.74 2.7a2.11 2.11 0 0 1-1.13.91c-.23.07-.49.1-.74.07-.2-.02-.38-.08-.55-.18l-.17-.1-.28-.21c-.4-.3-.61-.77-.62-1.24-.02-.45.13-.88.38-1.24l1.6-2.6a3.37 3.37 0 0 1 1.83-5.3ZM1.8 8.62l-.04.06a.6.6 0 0 0-.13.35c0 .04.01.06.02.07v.01l.29.21h.1a.71.71 0 0 0 .32-.27v-.02l1.35-2.1a1.05 1.05 0 0 1-.1-.06l-.27-.18a7.42 7.42 0 0 1-.25-.17l-1.3 2.1Zm3.95-7.04a1.87 1.87 0 0 0-1.89 3.23C5.31 5.66 7.85 6.38 9 6.67l.9-1.54-.43-.44-.56.96a.6.6 0 0 1-1.03-.6l.7-1.22a17.74 17.74 0 0 0-2.82-2.25Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.2 8a.76.76 0 0 1 1.06.11l.78.97a.75.75 0 0 1-1.17.94l-.77-.97A.75.75 0 0 1 10.2 8Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.25 6.64a.75.75 0 0 1 1.03-.27l1.06.64a.75.75 0 1 1-.76 1.29l-1.07-.64a.75.75 0 0 1-.26-1.02Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m12.75 4.5 1.22.18a.75.75 0 1 1-.22 1.48l-1.23-.18a.75.75 0 0 1 .23-1.49Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_26123_2704"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = heatprotectionhair;